import { FC } from 'react';
import { IconSVG, IconSVGComponentProps } from '../IconComponent';

export const SplitExpensesSeparateShared: FC<IconSVGComponentProps> = ({
    ...props
}) => {
    return (
        <IconSVG
            width="63px"
            height="39px"
            viewBox="0 0 63 39"
            fill="none"
            {...props}
        >
            <path
                d="M15.1827 19.4902V7.68399C15.1827 6.53734 16.4984 5.8348 17.5202 6.43585L36.8838 17.8261C38.181 18.5892 38.181 20.3913 36.8838 21.1544L17.5202 32.5446C16.4984 33.1457 15.1827 32.4431 15.1827 31.2965V19.4902Z"
                fill="#CF7135"
                style={{ fill: 'color(display-p3 0.8118 0.4431 0.2078)' }}
                fillOpacity={1}
                strokeWidth={0}
            />
            <g style={{ mixBlendMode: 'multiply' }}>
                <path
                    d="M47.6415 19.8496L47.6415 31.6559C47.6415 32.8025 46.3258 33.505 45.304 32.904L25.9405 21.5138C24.6432 20.7507 24.6432 18.9485 25.9405 18.1854L45.304 6.79523C46.3258 6.19418 47.6415 6.89671 47.6415 8.04336L47.6415 19.8496Z"
                    fill="#6DBBF3"
                    style={{ fill: 'color(display-p3 0.4275 0.7333 0.9529)' }}
                    fillOpacity={1}
                    strokeWidth={0}
                />
            </g>
        </IconSVG>
    );
};
